import { render, staticRenderFns } from "./DatosCompradoresComponent.vue?vue&type=template&id=1ee8aadb&scoped=true"
import script from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosCompradoresComponent.vue?vue&type=style&index=0&id=1ee8aadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee8aadb",
  null
  
)

export default component.exports